"use client";

import { useCallback } from "react";
import { useAuth } from "@/contexts/auth-context";
import { withDiamondPass } from "@/lib/billing/diamond-pass";
import { lockedToolTier } from "@/lib/billing/tool-access";
import type { BundleTierId } from "@/lib/billing/bundle-entitlements";

export function useLockedToolTier(): (href: string) => BundleTierId | null {
  const { user, isLoading, subscriptions, diamondPass } = useAuth();
  return useCallback(
    (href: string) =>
      !user || isLoading ? null : lockedToolTier(href, withDiamondPass(subscriptions, diamondPass ? [diamondPass] : [])),
    [user, isLoading, subscriptions, diamondPass],
  );
}
